import { render, staticRenderFns } from "./Headerbutton.vue?vue&type=template&id=d2bcc806&scoped=true&"
import script from "./Headerbutton.vue?vue&type=script&lang=js&"
export * from "./Headerbutton.vue?vue&type=script&lang=js&"
import style0 from "./Headerbutton.vue?vue&type=style&index=0&id=d2bcc806&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2bcc806",
  null
  
)

export default component.exports